import React from 'react';
import PropTypes from 'prop-types';

import article from './Article.module.scss';
import styles from './TextContent.module.scss';

const TextContent = ({title, children, ...props}) => (
  <div className={styles.container} {...props}>
    <div className="wrap">
      <article className={styles.wrap}>
        {title ? <h2 className={styles.title}>{title}</h2> : null}

        <div className={article.text}>
          {children}
        </div>
      </article>
    </div>
  </div>
);

TextContent.propTypes = {
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  children: PropTypes.node,
};

export default TextContent;
